import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationService } from '../../services';

@Component({
  selector: 'app-navigation-drawer',
  templateUrl: './navigation-drawer.component.html',
  styleUrls: ['./navigation-drawer.component.scss']
})
export class NavigationDrawerComponent {

  @Input() sideNav: MatSidenav;
  @Output() linkSelected: EventEmitter<any> = new EventEmitter();

  navigation: NavigationService

  constructor(navigationService: NavigationService) {
    this.navigation = navigationService;
  }

  /**
   * Whether or not the user is proxying.
   */
  isProxying() {
    return this.navigation.proxiedUnit != null;
  }

  /**
   * Stops proxying and then emits our event that we've selected a link.
   */
  stopProxying() {
    this.navigation.stopUnitProxying()
    this.onLinkSelected();
  }

  /**
   * Emits an event stating that the user has selected a link.
   */
  onLinkSelected(): void {
    this.linkSelected.emit(null);
  }
}
